import { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import api from "@/lib/api";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";

export default function ConfirmEmailChange() {
  const [params] = useSearchParams();
  const token = params.get("token");
  const [state, setState] = useState({ status: "working" });

  useEffect(() => {
    if (!token) {
      setState({ status: "error", detail: "Missing confirmation token." });
      return;
    }
    api.post("/auth/confirm-email-change", { token })
      .then(({ data }) => setState({ status: "ok", detail: data.detail, email: data.email }))
      .catch((e) => setState({
        status: "error",
        detail: typeof e.response?.data?.detail === "string" ? e.response.data.detail : "Something went wrong.",
      }));
  }, [token]);

  return (
    <div className="min-h-screen bg-appbg text-white flex items-center justify-center px-4">
      <div className="max-w-md w-full border border-neutral-800 bg-appcard p-8 text-center" data-testid="confirm-email-change-card">
        <div className="text-xs tracking-[0.3em] text-blaze mb-6">COACHCONNECT AI</div>
        {state.status === "working" && (
          <>
            <Loader2 className="mx-auto animate-spin text-volt" size={40} />
            <div className="heading text-2xl mt-4">UPDATING YOUR EMAIL…</div>
          </>
        )}
        {state.status === "ok" && (
          <>
            <CheckCircle2 className="mx-auto text-volt" size={40} />
            <div className="heading text-2xl mt-4" data-testid="confirm-email-success">EMAIL UPDATED</div>
            <p className="text-sm text-neutral-300 mt-3">
              Your account now belongs to <b className="text-white">{state.email}</b>. Use it the next time you sign in — all alerts and match notifications go there too.
            </p>
            <Link to="/coach" data-testid="confirm-email-dashboard-link"
              className="inline-block mt-6 bg-blaze text-white heading text-sm tracking-widest px-6 py-3 hover:glow-blaze transition-all">
              BACK TO MY DASHBOARD →
            </Link>
          </>
        )}
        {state.status === "error" && (
          <>
            <XCircle className="mx-auto text-blaze" size={40} />
            <div className="heading text-2xl mt-4" data-testid="confirm-email-error">LINK PROBLEM</div>
            <p className="text-sm text-neutral-300 mt-3">{state.detail}</p>
            <Link to="/coach/profile" className="inline-block mt-6 border border-volt text-volt heading text-sm tracking-widest px-6 py-3 hover:bg-volt hover:text-white transition-all">
              REQUEST AGAIN FROM PROFILE →
            </Link>
          </>
        )}
      </div>
    </div>
  );
}
